<template>
  <layout>
    <page-header :actions="actions" :header="$t('general.edit')" />
    <div class="content">
      <resource-form
        :id="$route.params.id"
        :show-cancel-button="true"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'billing-info'

export default {
  name: 'BillingInfoEdit',

  components: {
    ResourceForm,
  },

  computed: {
    actions() {
      return []
    },
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
